import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import { useTranslation } from "react-i18next";
import StaffManagementContent from "../../components/Pages/StaffManagement";

const { displayName } = config;

export default function StaffManagement(): React.ReactNode | null {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${displayName}: Users`;
  }, []);

  return (
    <Layout title="Staff Management">
      <StaffManagementContent />
    </Layout>
  );
}
